import { IPulpoBag } from '../flight-booking/pulpoBag.model';
import { ProviderDebugInfo } from './providerDebugInfo.model';

export interface UpsellOutput extends ProviderDebugInfo {
  transactionId: string;
  // Same PulpoBag shape as /luggage-catalog's bags (PUL-3218), but each one
  // is a whole branded fare rather than an ancillary bag: relatedId is the
  // fare basis (the code to send back to /quote), metadata the brand name,
  // info a ready-to-display label, weight the allowance in kg - or null when
  // the airline counts pieces (e.g. Air France long-haul) - and realPrice
  // the per-traveller delta over the offer's current fare. quantity and
  // maximumQuantity are both the traveller count: a fare change applies to
  // every traveller at once. Only same-cabin fares, one (the cheapest) per
  // allowance level. An empty array is a valid, non-error result: no fare
  // with an included bag was found for this offer.
  bags: IPulpoBag[];
  rawContent: string | null;
  originalRequest: string;
  originalResponse: string;
}

/**
 * One label for a branded fare wherever it's shown (results chips, quote
 * panel): info is the backend's ready-made text, and weight is null when the
 * airline counts pieces rather than kilos (Air France long-haul), so it must
 * never end up as "nullkg".
 */
export function upsellFareLabel(bag: IPulpoBag): string {
  return bag.info || bag.metadata || (bag.weight ? bag.weight + 'kg' : '');
}
